var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVarchatIconUser2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1823_74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.256 0H26.744C11.9737 0 0 11.9737 0 26.744V213.256C0 228.026 11.9737 240 26.744 240H213.256C228.026 240 240 228.026 240 213.256V26.744C240 11.9737 228.026 0 213.256 0Z",
    fill: "#344D66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.144 70.856C169.144 98 147.144 120 120 120C92.856 120 70.856 98 70.856 70.856",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.856 70.856C70.856 43.712 92.856 21.712 120 21.712C147.144 21.712 169.144 43.712 169.144 70.856",
    fill: "#C5E4E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.936 120H93.0558C63.1678 120 38.9438 144.224 38.9438 174.112V240H201.048V174.112C201.048 144.224 176.824 120 146.936 120Z",
    fill: "#5ABEBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.744 2.5H213.256C226.646 2.5 237.5 13.3544 237.5 26.744V213.256C237.5 226.646 226.646 237.5 213.256 237.5H26.744C13.3544 237.5 2.5 226.646 2.5 213.256V26.744C2.5 13.3544 13.3544 2.5 26.744 2.5Z",
    stroke: "#344D66",
    strokeWidth: 5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1823_74"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 240,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVarchatIconUser2);
export default __webpack_public_path__ + "static/media/varchat-icon-user-2.d455259f9b4da2895e872ee886a57650.svg";
export { ForwardRef as ReactComponent };